import { Box, LinearProgress, Typography } from '@mui/material';
import { memo } from 'react';

interface ProgressIndicatorProps {
  current: number;
  total: number;
}
function ProgressIndicator({ current, total }: ProgressIndicatorProps): JSX.Element {
  return (
    <Box sx={{ width: '100%', mb: 0, height: 30 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, ml: 1 }}>
        <Typography variant="body2" sx={{ fontSize: '16px', fontWeight: 400 }}>{`${current}/${total}`}</Typography>
      </Box>
      <LinearProgress variant="determinate" value={(current / total) * 100} sx={{ backgroundColor: '#EBEBEB' }} />
    </Box>
  );
}

export default memo(ProgressIndicator);
